import { render, staticRenderFns } from "./UserMenuEntry.vue?vue&type=template&id=4252d05c&scoped=true"
import script from "./UserMenuEntry.vue?vue&type=script&lang=js"
export * from "./UserMenuEntry.vue?vue&type=script&lang=js"
import style0 from "./UserMenuEntry.vue?vue&type=style&index=0&id=4252d05c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4252d05c",
  null
  
)

export default component.exports